export const ROUTES = {
  HOME: '/',
  COMMERCIALSUBSCRIPTION: '/commercial-subscription',
  COMMERCIALSUBSCRIPTIONLOGIN: '/commercial-subscription-login',
  COMMERCIALSUBSCRIPTIONSIGNUP: '/commercial-subscription-signup',
  COMMERCIALSUBSCRIPTIONDASHBOARD: '/commercial-subscription-dashboard',
  SUCCESSFULCHECKOUT: '/successful-checkout',
  TERMSOFSERVICE: '/terms-of-service',
  PRIVACYINFO: '/privacy-info',
  MUSICMIND: '/musicmind',
  LYDBRANDING: '/lydBranding',
  KONTAKT: '/kontakt',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  UPLOADCONTENT: '/upload-content',
  LIVECONTENT: '/live-content',
  PLAYLIST: '/playlist',
  HANDLETAGS: '/handle-tags',
  TAGGEDPLAYLIST: '/tagged-playlist',
  TAGGEDPLAYLISTDETAIL: '/tagged-playlist-detail',
  TAGGEDCONTENT: '/tagged-content',
  UNITS: '/units',
  MUSIC: '/music',
  PRESENTATION: '/presentations',
  DYNAMICPLAYLIST: '/dynamic-playlist',
  ABOUTUS:'/about-us',
  SIGNAGE:'/signage',
  MUSIK: '/musik',
}